import ViewJoonDevice from './ViewJoonDevice';

export default ViewJoonDevice;
